import { render, staticRenderFns } from "./Mainmenu.vue?vue&type=template&id=20ac5242&scoped=true"
import script from "./Mainmenu.vue?vue&type=script&lang=js"
export * from "./Mainmenu.vue?vue&type=script&lang=js"
import style0 from "./Mainmenu.vue?vue&type=style&index=0&id=20ac5242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac5242",
  null
  
)

export default component.exports